import { IMemberClient } from "@wingspanhq/payments/dist/interfaces";
import React, { ReactNode } from "react";
import {
  useInvoicesQuery,
  useInvoiceTemplatesQuery,
  useMemberClientsQuery
} from "../../../query/payments/queries";
import { getClients } from "../../../query/payments/selectors";
import { WSQueries } from "../../../query/WSQuery";

type Props = {
  loader?: ReactNode;
  zeroState?: ReactNode;
  children: (memberClients: IMemberClient[]) => ReactNode;
  limit?: number;
};

export const RecentClientsContainer: React.FC<Props> = ({
  loader,
  children,
  zeroState,
  limit
}) => {
  const memberClientsQuery = useMemberClientsQuery();
  const invoicesQuery = useInvoicesQuery();
  const invoiceTemplatesQuery = useInvoiceTemplatesQuery();

  return (
    <WSQueries
      queries={{ memberClientsQuery }}
      renderLoader={loader ? () => loader : undefined}
    >
      {({ memberClientsQuery }) => {
        const clients = getClients(memberClientsQuery.data);
        const invoices = invoicesQuery.data || [];
        const invoiceTemplates = invoiceTemplatesQuery.data || [];

        const dataToSort = clients.map(memberClient => {
          const datesToCompare = [memberClient.createdAt.getTime()];

          invoices
            .filter(
              invoice => invoice.memberClientId === memberClient.memberClientId
            )
            .forEach(invoice => {
              datesToCompare.push(invoice.createdAt.getTime());
            });

          invoiceTemplates
            .filter(
              invoiceTemplate =>
                invoiceTemplate.invoiceData.memberClientId ===
                memberClient.memberClientId
            )
            .forEach(invoiceTemplate => {
              datesToCompare.push(invoiceTemplate.createdAt.getTime());
            });

          return {
            memberClient,
            latestActionAt: new Date(Math.max(...datesToCompare))
          };
        });

        dataToSort.sort((a, b) => {
          return a.latestActionAt < b.latestActionAt ? 1 : -1;
        });

        const recentMemberClients = dataToSort
          .map(item => item.memberClient)
          .slice(0, limit);

        return recentMemberClients.length > 0
          ? children(recentMemberClients)
          : zeroState
          ? zeroState
          : null;
      }}
    </WSQueries>
  );
};
